import { getArticleNames } from "src/utils/commonFunc";
import { ARTICLE_NUMBERS, NEW_ARTICLES } from "src/utils/constants";

/**
 * Updates an existing article in the other articles data
 * @param {Object} params The parameters object
 * @param {Object} params.otherArticlesUI The UI state object containing the item being edited
 * @param {Object} params.selectedTab The currently selected tab information
 * @param {Function} params.setOtherArticlesData Function to update the other articles data
 * @param {Function} params.setOtherValuesChanged Function to mark values as changed
 * @param {Function} params.setOtherArticlesUI Function to update the UI state
 * @param {Object} data The form data
 * @param {Function} calculateTotal Function to calculate the total value
 * @param {Function} calculateTotalInSelectedCurrency Function to calculate the total in selected currency
 */
export const onEditArticleForms = ({
    otherArticlesUI,
    selectedTab,
    setOtherArticlesData,
    setOtherValuesChanged,
    setOtherArticlesUI
}) => (data, calculateTotal, calculateTotalInSelectedCurrency) => {
    const id = otherArticlesUI?.item?.id;
    const index = selectedTab.index;

    setOtherArticlesData((prevData) => {
        const updatedData = { ...prevData };

        if (updatedData[index]) {
            updatedData[index] = updatedData[index].map((item) => {
                const key = otherArticlesUI?.item?.key;
                // if the item's id matches the openModal id
                if (item.id === id) {
                    return {
                        ...item,
                        key: key,
                        label: key === NEW_ARTICLES.MATERIAL_VAT && data?.isMaterialExpenseTaxFree === "0" &&
                            (!data?.uploadFile || data.uploadFile.length === 0)
                            ? getArticleNames(ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF)
                            : key === NEW_ARTICLES.MATERIAL_VAT && data?.isMaterialExpenseTaxFree === "0" &&
                                (data?.uploadFile || data.uploadFile.length !== 0)
                                ? getArticleNames(ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX) : key === NEW_ARTICLES.MATERIAL_VAT && data?.isMaterialExpenseTaxFree === "1"
                                    ? getArticleNames(ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE) : otherArticlesUI?.item?.label,
                        value: calculateTotal(),
                        valueInSelectedCurrency: calculateTotalInSelectedCurrency(),
                        data,
                    };
                }
                return item;
            });
        }

        return updatedData;
    });

    setOtherValuesChanged(true);
    setOtherArticlesUI({
        show: false,
    });
};